import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllOtherWork = () => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.getAllOtherWork();
  dispatch({
    type: TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getFilteredOtherWork = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.getFilteredOtherWork(page, pageSize);
  dispatch({
    type: TYPE.OTHER_WORK.GET_FILTERED_OTHER_WORK_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.GET_FILTERED_OTHER_WORK_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.GET_FILTERED_OTHER_WORK_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getAllOtherWorkByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.getAllOtherWorkByProfileId(id);
  dispatch({
    type: TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const insertOtherWork = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.insertOtherWork();
  dispatch({
    type: TYPE.OTHER_WORK.INSERT_OTHER_WORK_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.INSERT_OTHER_WORK_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm dữ liệu thành công!",
      })
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.INSERT_OTHER_WORK_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Thêm dữ liệu thất bại!",
      })
    );
    return { success: false, data: null };
  }
};

export const updateOtherWork = (id, payload) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.updateOtherWork(id);
  dispatch({
    type: TYPE.OTHER_WORK.UPDATE_OTHER_WORK_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.UPDATE_OTHER_WORK_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.UPDATE_OTHER_WORK_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật dữ liệu thất bại!",
      })
    );
    return false;
  }
};

export const deleteOtherWork = (id) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.deleteOtherWork(id);
  dispatch({
    type: TYPE.OTHER_WORK.DELETE_OTHER_WORK_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.DELETE_OTHER_WORK_SUCCESS,
      id,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.DELETE_OTHER_WORK_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xoá dữ liệu thất bại!",
      })
    );
    return false;
  }
};

// Sprint 2: admin "Yêu cầu khai lại" for other work.
export const requestRevisionOtherWork = (id, reason) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.requestRevisionOtherWork(id);
  const { response, error } = await apiCall({ ...api, payload: { reason } });
  if (!error && response?.status === 200 && response.data?.success) {
    if (response.data.data) {
      dispatch({
        type: TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_SUCCESS,
        payload: response.data.data,
        meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
      });
    }
    dispatch(notification({ type: 'success', message: 'Đã gửi yêu cầu khai lại' }));
    return true;
  }
  dispatch(notification({
    type: 'error',
    message: response?.data?.message || 'Yêu cầu khai lại thất bại',
  }));
  return false;
};

export const acceptOtherWork = (id, accept) => async (dispatch) => {
  const api = API_URLS.OTHER_WORK.acceptOtherWork(id, accept);
  dispatch({
    type: TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_LOADING,
    meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xác nhận thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_FAILURE,
      meta: { prefix: [PREFIX.OTHER_WORK, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xác nhận thất bại!",
      })
    );
    return false;
  }
};

